(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-main"]) return;
  try {
    
document.querySelectorAll('[data-product-section]').forEach(function(section){
var select=section.querySelector('[name=id]'),image=section.querySelector('#product-image'),price=section.querySelector('#product-price'),stock=section.querySelector('[data-stock]'),button=section.querySelector('[data-add]');
function photo(url,alt){if(image&&url){image.removeAttribute('srcset');image.src=url;if(alt)image.alt=alt;}}
section.querySelectorAll('[data-photo].fidshy-thumb').forEach(function(thumb){thumb.addEventListener('click',function(){photo(thumb.dataset.photo,thumb.dataset.alt)})});
if(select&&select.tagName==='SELECT')select.addEventListener('change',function(){var option=select.options[select.selectedIndex],available=option.dataset.available==='true';price.textContent=option.dataset.price;stock.textContent=available?stock.dataset.yes:stock.dataset.no;button.disabled=!available;button.textContent=available?button.dataset.label:stock.dataset.no;photo(option.dataset.photo);var url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squish-break"] && !Shopify.designMode) return;
  try {
    
(function(){
document.querySelectorAll('[data-squish-game]').forEach(function(game){
if(game.dataset.ready)return;game.dataset.ready='true';
var button=game.querySelector('.squish-toy'),status=game.querySelector('.squish-status'),reward=game.querySelector('.squish-reward'),dots=game.querySelectorAll('.squish-dots i'),count=0;
function render(){dots.forEach(function(dot,i){dot.classList.toggle('done',i<count)});status.textContent=count>=3?status.dataset.done:status.dataset.progress.replace('__COUNT__',String(count));if(count>=3)reward.hidden=false;}
function release(){button.classList.remove('is-pressed');}
button.addEventListener('pointerdown',function(){button.classList.add('is-pressed')});
button.addEventListener('pointerup',release);button.addEventListener('pointercancel',release);button.addEventListener('pointerleave',release);button.addEventListener('blur',release);
button.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){if(e.repeat){e.preventDefault();return;}button.classList.add('is-pressed')}});
button.addEventListener('keyup',release);
button.addEventListener('click',function(){release();count=Math.min(3,count+1);render();});
render();
});
})();

  } catch(e) { console.error(e); }
})();
})();
